import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { Label } from "components/input/Label";
import OperacaoProducaoService from "service/meta/producao/OperacaoProducaoService";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";

const operacaoProducaoService = new OperacaoProducaoService();

export default function OperacaoProducaoCadastro() {

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [operacaoProducao, setOperacaoProducao] = useState<OperacaoProducao>(new OperacaoProducao());
    const [titulo, setTitulo] = useState<string>('Operação');

    function validar() {

        if (!operacaoProducao.descricao) {
            setError("descricao", { type: "manual", message: "Descrição é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={operacaoProducao} service={operacaoProducaoService} setModel={(value: OperacaoProducao) => setOperacaoProducao(value)} validar={() => validar()} urlService="/operacaoProducao" pathCadastro="/operacaoProducao" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex", marginTop: 4 }}>
                <Checkbox
                    checked={operacaoProducao.qualidade}
                    onChange={(e) => { setOperacaoProducao({ ...operacaoProducao, qualidade: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Qualidade</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Descrição</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.descricao ? "p-invalid" : ""}
                        required value={operacaoProducao.descricao}
                        style={{ width: '30%' }}
                        {...register("descricao", {
                            onChange: (e) => {
                                setOperacaoProducao({ ...operacaoProducao, descricao: e.target.value })
                                clearErrors("descricao")
                            }
                        })}
                    />
                </div>
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Quantidade de Operadores</Label>
                <div className="col-sm-12">
                    <InputNumber
                        value={operacaoProducao.quantidadeOperadores} onChange={(e) => setOperacaoProducao({ ...operacaoProducao, quantidadeOperadores: e.value || 0 })}
                        locale='pt-BR' useGrouping={false}
                        maxFractionDigits={3}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Tempo de execução (em segundos)</Label>
                <div className="col-sm-12">
                    <InputNumber
                        value={operacaoProducao.tempoExecucao} onChange={(e) => setOperacaoProducao({ ...operacaoProducao, tempoExecucao: e.value || 0 })}
                        locale='pt-BR' useGrouping={false}
                        suffix=" s" maxFractionDigits={0}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

        </BaseCadastro>
    )
}
